const e=typeof window=="undefined"||typeof document=="undefined";export{e as isServer};
